import { Grid, Skeleton, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { TakeawayProductCardSkeleton } from "./TakeawayProductCardSkeleton"

const SKELETON_GROUPS: readonly number[] = [4, 3]

const useStyles = makeStyles()(() => ({
    groupTitle: {
        transform: "none",
        borderRadius: ".375rem",
    },
}))

export function TakeawayMenuContentSkeleton() {
    const { classes } = useStyles()

    return (
        <Stack gap="2rem">
            {SKELETON_GROUPS.map((count, groupIndex) => (
                <Stack gap="1.5rem" key={groupIndex}>
                    <Skeleton
                        variant="rounded"
                        animation="wave"
                        width="10rem"
                        height="1.5rem"
                        className={classes.groupTitle}
                    />
                    <Grid container gap="1.5rem" alignItems="stretch">
                        {Array.from({ length: count }).map((_, cardIndex) => (
                            <TakeawayProductCardSkeleton key={cardIndex} />
                        ))}
                    </Grid>
                </Stack>
            ))}
        </Stack>
    )
}
